const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
const PDF_EXTENSIONS = ['.pdf'];
const EXCEL_EXTENSIONS = ['.xlsx', '.xls', '.xlsm', '.xlsb'];

export const isImageFile = (fileName: string): boolean => {
  if (!fileName) return false;
  const ext = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
  return IMAGE_EXTENSIONS.includes(ext);
};

export const isPdfFile = (fileName: string): boolean => {
  if (!fileName) return false;
  const ext = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
  return PDF_EXTENSIONS.includes(ext);
};

export const isExcelFile = (fileName: string): boolean => {
  if (!fileName) return false;
  const ext = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
  return EXCEL_EXTENSIONS.includes(ext);
};

export const getFileTypeIcon = (fileName: string): 'image' | 'pdf' | 'excel' | 'file' => {
  if (isImageFile(fileName)) return 'image';
  if (isPdfFile(fileName)) return 'pdf';
  if (isExcelFile(fileName)) return 'excel';
  return 'file';
};
